import { Injectable } from '@angular/core';

import { URL } from '@app-shared/constants/service-urls';
import { ApiService } from '@app-shared/services/api.service';
import { APIRequest } from '@app-shared/services/req-res.types';
import { UtilService } from '@app-shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class DataMappingService {
  
  constructor(
    private api: ApiService,
    private util: UtilService
  ) {}

  get jwt(): string | null {
    return localStorage.getItem('JwtToken');
  }
  get orgID(): string | null{
    const value = localStorage.getItem('OrgId');
    if (value) {
      return this.util.decrypt(value);
    }
    return null;
  }

  createMapping(data: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.INBOUND_API.DATA_MAPPING, postData );
  }

  getAllMapping() {
    return this.api.get(URL.INBOUND_API.DATA_MAPPING);
  }

  updateStatusMapping(id: any, data: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data,
      }
    };

    return this.api.post(URL.INBOUND_API.UPDATE_STATUS+id, postData);
  }
}